var withStreamingServer = require('./withStreamingServer');

module.exports = withStreamingServer;
